/**
 * Account creation and creating-device bootstrap authority are one atomic
 * client contract. Neither discriminator may substitute for the other.
 */
export function hasExactCreatedAccountBootstrapAuthority(value) {
  return Boolean(
    value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    value.accountCreated === true &&
    value.localDataBootstrapRequired === true,
  );
}

export function withExactCreatedAccountBootstrapAuthority(value, activate) {
  if (!hasExactCreatedAccountBootstrapAuthority(value) || typeof activate !== "function") {
    return false;
  }
  return activate();
}
